import { normalizeRole } from '@/auth/permissions';

export const GABINETO_PILOT_EMAIL = 'sergio@sien.com';

export function canAccessGabineto(email?: string | null, role?: string | null): boolean {
  return (
    normalizeRole(role) === 'ADMIN' &&
    (email ?? '').trim().toLowerCase() === GABINETO_PILOT_EMAIL
  );
}
